import React, { useState, useEffect } from "react";
import { getobj } from "../apicall/apicall";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { TableRow } from "@mui/material";
import { StyledTableCell, StyledTableRow } from "../style/style";
import TableHead from "@mui/material/TableHead";
import Pagination from "@mui/material/Pagination";

export default function YearlyBillingStat(props) {
  const [loader, setloaded] = useState(true);
  const [page, setpage] = useState(1);
  const [devices, setDevices] = useState([]);
  const [totalpage, setpaget] = useState();

  useEffect(() => {
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "user/bill-stat/" +
      props.customerId +
      "/?page=" +
      page +
      "&device_group=" +
      props.data["data"] +
      "&start_date=" +
      props.data["date"]["from_utc"] +
      "&bill_type=" +
      props.data["bill_type"];
    const res = getobj(url);
    res.then(function (r) {
      if (r.count % 5 > 0) {
        setpaget(Math.floor(r.count / 5) + 1);
      } else {
        setpaget(Math.floor(r.count / 5));
      }
      setDevices(r.results);
      setloaded(false);
    });
  }, [page, props.data, props.customerId]);

  const handlePagechange = (event, value) => {
    setpage(value);
    setloaded(true);
  };

  return (
    <div>
      {loader ? (
        <img
          src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
          alt="loading..."
        />
      ) : (
        <TableContainer>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <StyledTableCell>
                  <b>Device Group</b>
                </StyledTableCell>
                <StyledTableCell>
                  <b>Model</b>
                </StyledTableCell>
                <StyledTableCell>
                  <b>Bluetooth ID</b>
                </StyledTableCell>
                <StyledTableCell>
                  <b>IMEI</b>
                </StyledTableCell>
                <StyledTableCell>
                  <b>Provisioned Date</b>
                </StyledTableCell>
                <StyledTableCell>
                  <b>Activation Date</b>
                </StyledTableCell>
                <StyledTableCell>
                  <b>Free Period</b>
                </StyledTableCell>
                {props.data["data"] === "hub" && (
                  <StyledTableCell>
                    <b>Hub Name</b>
                  </StyledTableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {devices &&
                devices.map((device) => (
                  <StyledTableRow key={device.id}>
                    <StyledTableCell>{device.group}</StyledTableCell>
                    <StyledTableCell>{device.model}</StyledTableCell>
                    <StyledTableCell>{device.mac_address}</StyledTableCell>
                    <StyledTableCell>{device.imei_number}</StyledTableCell>
                    <StyledTableCell>
                      {new Date(device.created_at)
                        .toLocaleString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          timeZone: "UTC",
                        })
                        .replace(/,/g, " ")}
                    </StyledTableCell>
                    <StyledTableCell>
                      {new Date(device.activation_date)
                        .toLocaleString("en-us", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                          timeZone: "UTC",
                        })
                        .replace(/,/g, " ")}
                    </StyledTableCell>
                    <StyledTableCell>
                      {device.free_period.free_time_period}
                    </StyledTableCell>
                    {props.data["data"] === "hub" && (
                      <StyledTableCell>{device.hub_id.hub_id}</StyledTableCell>
                    )}
                  </StyledTableRow>
                ))}
            </TableBody>
            <Pagination
              count={totalpage}
              page={page}
              variant="outlined"
              color="primary"
              onChange={handlePagechange}
            />
          </Table>
        </TableContainer>
      )}
    </div>
  );
}
